import { StyledButtonContainer } from './style'

function StyledButton({
  type,
  className = '',
  title = '',
  height = 48,
  width = '100%',
  onClick = () => {},
  disabled,
}) {
  return (
    <StyledButtonContainer
      type={type}
      className={className}
      height={height}
      width={width}
      onClick={onClick}
      disabled={disabled}
    >
      {title}
    </StyledButtonContainer>
  )
}

export default StyledButton
